import { Injectable, inject } from '@angular/core';
import { TODO } from '@b2b/types/core';

import { UIB_MODAL_PORT } from '../../modal/uib-modal.port';
import { STATE_PORT } from '../../utils';

/**
 * FeatureCustomersService — Angular 18.
 *
 * Ported 1:1 from apps/b2b-ui/common/services/feature/customers/customers.service.ts
 * (legacy AngularJS name 'FeatureCustomersService'). Feature-flag descriptor
 * plus the `prompt()` order-modal flow.
 *
 * Legacy deps `$state` / `$uibModal` are reached via STATE_PORT / UIB_MODAL_PORT
 * (both lifetime-of-shell bridges wired in core.module.ts). Internal to
 * FeatureService (injected directly), so it is not downgrade-registered.
 * Wave 3 item #26.
 */
@Injectable({ providedIn: 'root' })
export class FeatureCustomersService {
  readonly name = 'customers';
  readonly key = 'enableCustomersOrgCheckout';

  private $state = inject(STATE_PORT);
  private $uibModal = inject(UIB_MODAL_PORT);

  /**
   * Prompts using modal in the final location where the feature will eventually live
   * This functionality is currently encapsulated within the feature
   * If this flag is removed we will want to migrate this code into the view where
   * this method is called from
   */
  prompt(customer: TODO) {
    this.$uibModal
      .open<{ params: { customerId: number; accountId?: number } }>({
        templateUrl: 'views/application/views/customers/modals/order/order.tpl.html',
        size: 'md',
        controller: 'CustomersModalsOrderController',
        resolve: {
          customer: () => customer,
        },
      })
      .result.then((response) => {
        this.$state.go('application.orders.create', response.params);
      })
      .catch(function () {
        // noop
      });
  }
}
